module.exports = __webpack_public_path__ + "img/icn_brand14.59b95cd9.svg";